module.exports = __webpack_public_path__ + "static/media/slideimage-5.305c99af.jpg";